
export { AuthRoutes as Auth } from "./src/routes/auth"